import api from "../../index";

// Create mobileCopilotChat
export const createMobileCopilotChat = async (data: any) => {
  return await api.post("/mobile-copilot-chat", data);
};

// Get all getAllMobileCopilotChats
export const getAllMobileCopilotChats = async () => {
  return await api.get("/mobile-copilot-chats");
};

// Get all mobile copilot chats paginated search
export const getAllMobileCopilotChatsPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/mobile-copilot-chats/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/mobile-copilot-chats/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get mobileCopilotChat by id
export const getMobileCopilotChatById = async (id: any) => {
  return await api.get(`/mobile-copilot-chat/${id}`);
};

// Update mobileCopilotChat by id
export const updateMobileCopilotChatById = async (id: any, data: any) => {
  return await api.put(`/mobile-copilot-chat/${id}`, data);
};

// Delete mobileCopilotChat by id
export const deleteMobileCopilotChatById = async (id: any) => {
  return await api.delete(`/mobile-copilot-chat/${id}`);
};

// Upload mobileCopilotChat image
export const uploadMobileCopilotChatImage = async (
  values: any,
  config: any
) => {
  return await api.post("/mobile-copilot-chat/image", values, config);
};
